import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { CircularProgress } from "../UI/CircularProgress/CircularProgress";
import { Safearea } from "../UI/Safearea/Safearea";
import { Row, Col } from "../UI/Customstrap/Customstrap";
import { Container } from "../UI/Container/Container";
import { getSession, getCurrentAccount, getSavedPersonInfo } from "../../reducers/selectors";
import { getQuestions, updateAnswers, getPersonInfo } from "../../services/api/person";
import { currentAccountSet, personInfoSet } from "../../actions/entities";
import GenericButton from "../UI/Button/Button";
import style from "./ProfileTest.scss";
import { showToast } from "../../utils/helper";
import { Icons } from "../UI/Icon/Icon";
import { MyData } from "../Layout/MyData/MyData";
import { Prompt } from "react-router-dom";

export const ProfileTest = ({ history, toggleRedoTest }) => {
  const [start, setStart] = useState(false);
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [showTestQuestions, setShowTestQuestions] = useState(false);
  const [showMyData, setShowMyData] = useState(false);
  const personInfo = useSelector(getSavedPersonInfo);
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(() => true);
    getQuestions()
      .then(({ response }) => {
        setQuestions(response.questions);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(() => false);
      });
  }, []);

  const setAnswer = (questionIndex, answerIndex) => {
    const newQuestions = [...questions];

    newQuestions.find((question) => question.QuestionId === questionIndex).Answer = newQuestions
      .find((question) => question.QuestionId === questionIndex)
      .Answer.map((answerItem) => {
        return {
          ...answerItem,
          AnswerIsResponse: false,
        };
      });

    newQuestions
      .find((question) => question.QuestionId === questionIndex)
      .Answer.find((answer) => answer.AnswerId === answerIndex).AnswerIsResponse = true;

    setQuestions(newQuestions);
  };

  const onConfirm = () => {
    const newQuestions = questions.filter((questionItem) => {
      if (questionItem.Answer.find((answerItem) => answerItem.AnswerIsResponse)) return questionItem;
    });
    if (newQuestions.length < questions.length) {
      showToast("Debe responder todas las preguntas", true);
      return;
    } else {
      setLoading(() => true);
      updateAnswers({ sdtQuestion: questions })
        .then(({ response }) => {
          if (response.sdtresult.Code !== 200) showToast("Error enviando respuestas", true);
          else {
            getPersonInfo()
              .then(({ response }) => {
                dispatch(personInfoSet(response.personInfo));
                history.push("/investorProfile/profileTestAnswer");
                window.location.reload();
              })
              .catch((err) => console.error(err))
              .finally(() => {
                setLoading(() => false);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
      toggleShowTestQuestions();
      toggleShowMyData();
    }
  };

  const toggleShowTestQuestions = () => {
    setShowTestQuestions((stateTestQuestions) => !stateTestQuestions);
    setStart(!start);
  };

  const toggleShowMyData = () => {
    setShowMyData((stateMyData) => !stateMyData);
  };

  if (!personInfo || loading)
    return (
      <div className={style.subAssetClassDisplay}>
        <CircularProgress />
      </div>
    );

  return (
    <div className={style.subAssetClassDisplay}>
      <Row>
        <Col xs={12} className={style.titleWrapper}>
          <span className={style.iconWrapper} onClick={toggleRedoTest}>
            <Icons.ArrowLeftIcon className={style.iconArrow} />
          </span>
          <span className={style.title}>Perfil inversor</span>
        </Col>
        <hr />
      </Row>
      <div>
        {start ? (
          <Fragment>
            <Row>
              <Col>
                <Container className={style.profileTestWrapper}>
                  {questions.map((question, index) => {
                    return <Question key={index} question={question} setAnswer={setAnswer} />;
                  })}
                  <div className={style.buttonContainer}>
                    <GenericButton
                      label={"Confirmar"}
                      rounded
                      padding={"12px 36px 12px 36px"}
                      primary
                      handleClick={onConfirm}
                    ></GenericButton>
                  </div>
                </Container>
              </Col>
            </Row>
          </Fragment>
        ) : (
          <Fragment>
            <Row>
              <Col>
                <Container>
                  <div className={style.welcomeContainer}>
                    <div className={style.name}>{personInfo.PhysicalPersonFirstName},</div>
                    <div className={style.text}>
                      Para recomendar las mejores inversiones que se adapten a tus necesidades, queremos
                      conocerte mejor.
                    </div>

                    <div className={style.buttonContainer}>
                      <GenericButton
                        label={"Empezar"}
                        rounded
                        padding={"12px 36px 12px 36px"}
                        primary
                        handleClick={toggleShowTestQuestions}
                      ></GenericButton>
                    </div>
                  </div>
                </Container>
              </Col>
            </Row>
          </Fragment>
        )}
      </div>
      <Prompt
        when={showMyData}
        message={(location) => {
          toggleShowMyData();
          // No permitir la navegación hacia atrás
          return false;
        }}
      />
      {showMyData && <MyData toggleMyData={toggleShowMyData} />}
    </div>
  );
};

const Question = ({ question, setAnswer }) => {
  const [active, setActive] = useState("");

  return (
    <form className={style.questionContainer}>
      <p className={style.questionTitle}>{question.QuestionDescription}</p>
      {question.Answer.map((answer, index) => {
        const key = `${question.QuestionId}-${index}`;

        return (
          <div key={key} className={`${style.answerRow} ${active == key ? style.answerRowActive : ""}`}>
            <input
              type="radio"
              name="answer"
              id={key}
              style={{ accentColor: "#27272A" }}
              onClick={() => {
                setActive(key);
                setAnswer(question.QuestionId, answer.AnswerId);
              }}
            />
            <label className={style.answerText} for={key}>
              {answer.AnswerDescription}
            </label>
          </div>
        );
      })}
    </form>
  );
};
